const config = {
  version: '1.0',
  type: 'dev',
  apiUri: {
    v1: 'https://c4f900f8me.execute-api.eu-central-1.amazonaws.com/dev/v1/',
    v2: 'https://c4f900f8me.execute-api.eu-central-1.amazonaws.com/dev/v2/'
  },
  lpUri: 'https://veventytest.com',
  socket: 'wss://qhvyvgoxk6.execute-api.eu-central-1.amazonaws.com/production',
  fbOauth: '1055499531585629',
  pusher: '66ab9d27cd636c4cde78',
  tokbox: '47351561',
  stripe: 'pk_test_51I6LZPHcrUHKAWVTSbbBgOK4t3jiWSfgogtf2LoR5MUF3dH8c0fj31RiaKKbqFLih7svC16iDdiXFUmmE4GgHNkK00oLHJb7fp',
  intercom: 'bc8d3vgo',
  expo: true,
  sales: true,
  meet: true,
  tutorials: true,
  paidTickets: false
};

module.exports = config;
